import RadioButtonGroup from '../../../Common/RadioButtonGroup/RadioButtonGroup';
import React from 'react';
import { createFunctionOption } from './UserDefinedFunction.Helpers';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';

interface Props {
    isWaiting: boolean;
    functionNumber: number | null;
    functions: UserDefinedFunction[];
    onFunctionSelected: (number: number) => void;
}

class UserDefinedFunctionSelector extends React.Component<Props, { scrollLeft: number }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            scrollLeft: 0
        }

        this.onFunctionSelected = this.onFunctionSelected.bind(this);
    }

    onFunctionSelected(value: string, scrollLeft?: number): void {

        this.setState({ scrollLeft: scrollLeft || 0 }, () => {
            this.props.onFunctionSelected(parseInt(value));
        });
    }

    render(): JSX.Element {

        const options = this.props.functions.map(createFunctionOption);

        return (
            <>
                <RadioButtonGroup
                    className='sticky min-height-44px padding-10px overflow-x-auto'
                    options={options}
                    value={(this.props.functionNumber || options[0].value).toString()}
                    name="report-functions"
                    onChange={this.onFunctionSelected}
                    scrollLeft={this.state.scrollLeft} />
            </>
        );
    }
}

export default UserDefinedFunctionSelector;
